import './index.less';
import * as React from 'react';
import { observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import useDelayedFlag from '@src/utils/hooks/use-delayed-flag';
import CommonLoading from '@src/components/common-loading';
import Page from '@src/components/page';
import BackHomeLink from '@src/components/back-home-link';
import routeConfigs from '@src/pages/app-router/route-configs';
import MoActivityRules from '@src/ui-components/mo-activity-rules';
import MoBottomTabs from '@src/ui-components/mo-bottom-tabs';
import RulesStore from './store';

const styles = require('./index.less');

const RulesView = ({ store }) => {
  // 短于 300ms 的加载不渲染遮罩：缓存命中/快速响应不闪屏，慢请求照常出现
  const showLoading = useDelayedFlag(store.loadStatus === 'loading');
  const rule = store.rule;

  return (
    <Page className={styles.root}>
      <BackHomeLink to={routeConfigs.MAIN.getFormatPath()} />
      <MoActivityRules
        title={rule ? rule.title : '活动规则'}
        contentHtml={rule ? rule.contentHtml : ''}
        status={store.loadStatus}
        onRetry={store.loadActivityRules}
      >
        <MoBottomTabs activeRouteKey="RULES" onNavigate={store.navigateByTab} />
      </MoActivityRules>
      {/* {store.accountInfoStore.getComponent()} */}
      {showLoading ? (
        <div className={styles.loading} data-name="活动规则加载中">
          <CommonLoading />
        </div>
      ) : null}
    </Page>
  );
};

const ObservedRulesView = observer(RulesView);

export const RulesContent = () => {
  const store = useStore(() => new RulesStore());
  return <ObservedRulesView store={store} />;
};

const Rules = () => <RulesContent />;

export default Rules;
